'use client'

import { useRecentProductStore } from '@/store/recent-products'
import { useEffect } from 'react'

type Props = {
  product: Product | null
}

export const SetRecentProduct = ({ product }: Props) => {
  const { setRecentProducts } = useRecentProductStore()
  useEffect(() => {
    if (product == null) return
    setRecentProducts([product])
  }, [product, setRecentProducts])
  return null
}
